import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ButtonComponent, IconComponent } from '@sarasanalytics-com/design-system';
import { StoreService } from 'src/app/services/store/store.service';

@Component({
  selector: 'sa-message-view',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent],
  templateUrl: './message-view.component.html',
  styleUrl: './message-view.component.scss'
})
export class MessageViewComponent {

  @Input('props') props: IMessageView;
  @Output('onClick') onClick: EventEmitter<any> = new EventEmitter();

  private store = inject(StoreService);

  debounce = false;
  timerSeconds = 0;

  initialTimestamp: any;

  ngOnInit(){
    this.initialTimestamp = this.store.getResendLinkTimestamp();
    if(this.initialTimestamp){
      this.timerSeconds = this.getRemainingSeconds(this.initialTimestamp);
      this.runTimerClock();
    }
  }

  linkClick(evt: any, isDisabled: boolean){
    if(isDisabled)
      return;
    this.onClick.emit({type: this.props.link?.event || MessageViewEvent.RESEND, props: evt})
    if(evt.event === MessageViewEvent.RESEND){
      this.initialTimestamp = Date.now();
      this.store.setResendLiknTimestamp(this.initialTimestamp);
      this.timerSeconds = this.getRemainingSeconds(this.initialTimestamp);
      this.runTimerClock();
    }
  }
  buttonClick(evt: any) {
    if (!this.debounce) {
      this.debounce = true;
      this.onClick.emit({ type: MessageViewEvent.BUTTON, props: evt })
      setTimeout(() => {
        this.debounce = false;
      }, 500);
    } 
  }
  runTimerClock(){
    const clockInterval = setInterval(()=>{
      if(this.timerSeconds > 0){
        --this.timerSeconds;
      }else{
        this.timerSeconds = 0;
        clearInterval(clockInterval);
        this.store.removeResendLinkTimestamp();
      }
    }, 1000);
  }

  getRemainingSeconds(timestamp: any){
    const secondsTillNow = Math.floor((Date.now() - timestamp)/1000)
    if(secondsTillNow < 60){
      return 60-secondsTillNow
    }else{
      this.store.removeResendLinkTimestamp();
      return 0;
    }
  }
}

export interface IMessageView {
  icon?: string;
  state: 'success' | 'failure';
  title: string;
  link?: {
    icon?: string;
    event: MessageViewEvent,
    text: string;
    url: string;
  },
  items?: IMessageViewItem[]
}
export interface IMessageViewItem {
  type: 'TEXT' | 'EMAIL' | 'FOOTER' | 'LINK' | 'BUTTON',
  inlineItems?: IMessageViewItem[], /* Only Handles 'TEXT', 'EMAIL'  &  'LINK' */
  text?: string,
  email?: string;
  className?: 'sa-mv-footer' | string;
  link?: {
    icon?: string;
    event: MessageViewEvent,
    text: string;
    url: string;
  },

}
export enum MessageViewEvent {
  REFRESH = 'REFRESH',
  RESEND = 'RESEND',
  BUTTON = 'BUTTON'
}